import './InitializationError.scss'

const InitializationError = ({ error, isPending }) => (
  <div className="ng-python-initialization-error">
    <div role="alert">
      <strong>Python environment unavailable</strong>
      <p className="ng-python-initialization-error__message">{error.message}</p>
    </div>
    <p
        className="ng-python-initialization-error__message"
        role={isPending ? 'status' : undefined}
    >
      {isPending ? 'Trying to start Python again...' : 'Use Restart to try again.'}
    </p>
    <details>
      <summary>Technical details</summary>
      <pre>{error.details}</pre>
    </details>
  </div>
)

export default InitializationError
